import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

const NavHeading = styled.h1`
  font-size: ${fontSize('xl')};
  font-weight: 600;
  letter-spacing: 0.5px;
  padding-left: ${size(3.5)};
  width: 100%;
`

export default NavHeading
